import request from '@/utils/request';

let path = process.env.VUE_APP_AUTH_API || "";

//下载文件
export function previewFile(urlString) {
    return request({
        url: path + '/cloud/file/preview',
        method: 'post',
        data: urlString,
        responseType: 'blob'
    })
}

//下载文件
export function downloadFile(urlString) {
    return request({
        url: path + '/cloud/file/download',
        method: 'post',
        data: urlString,
        responseType: 'blob'
    })
}